<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="#">CH47F</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item active">
          <a class="nav-link" href="#">HOME</a>
        </li>
        <li class="nav-item ">
          <a class="nav-link" href="dustdevils">DUST DEVILS</a>
        </li>
        <li class="nav-item ">
          <a class="nav-link" href="flightplanning">FLIGHT PLANNING</a>
        </li>
        <li class="nav-item ">
          <a class="nav-link" href="horizonair">HORIZON AIR</a>
        </li>
        <li class="nav-item ">
          <a class="nav-link" href="notams">NOTAMS</a>
        </li>
        <li class="nav-item ">
          <a class="nav-link" href="regulations">REGULATIONS</a>
        </li>
        <li class="nav-item ">
          <a class="nav-link" href="trainig">TRAINING</a>
        </li>
        <li class="nav-item ">
          <a class="nav-link" href="weather">WEATHER</a>
        </li>
      </ul>
    </div>
  </nav>
